import { Control, Controller, FieldValues, Path } from 'react-hook-form'

interface CustomInputProps<T extends FieldValues> {
  colSpan: string
  id: Path<T>;
  label: string
  type?: string
  name?: Path<T>;
  control: Control<T>
  autoComplete?: string
}

export default function CustomInput<T extends FieldValues>({ colSpan, id, label, type = 'text', name, control, autoComplete }: CustomInputProps<T>) {
  return (
    <Controller
      name={name ? name : id}
      control={control}
      render={({ field, fieldState }) => (
        <div className={colSpan}>
          <label htmlFor={id as string} className="block text-sm font-medium leading-6 text-gray-900">
            {label}
          </label>
          <input
            type={type}
            id={id as string}
            autoComplete={autoComplete}
            {...field}
            aria-invalid={fieldState.error ? true : undefined}
            aria-describedby={fieldState.error ? `${id as string}-error` : undefined}
            className={`bg-gray-50 border text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${fieldState.error ? 'border-red-500' : 'border-gray-300'}`}
          />
          {fieldState.error && (
            <p id={`${id as string}-error`} className="mt-1 text-sm text-red-500" role="alert">{fieldState.error.message}</p>
          )}
        </div>
      )}
    />
  )
}
